// extracted by mini-css-extract-plugin
export default {"forms":"Join_forms__JzjXt","createForm":"Join_createForm__034s0","title":"Join_title__I9vE9","inlineForm":"Join_inlineForm__UMjp0","room":"Join_room__QrbWA"};